export default {
      id: "plus-corner-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#plus-corner-usage",
      toString: function () {
        return this.url;
      }
    }